import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import RightFilterToggle from '../components/RightFilterToggle';
import paginationFactory from 'react-bootstrap-table2-paginator';
import GridData from '../components/gridmodal/GridDataPackages';
// import { propTypes } from 'react-bootstrap/esm/Image';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
// import PriceFilter from '../components/CustomGridFilter';
import configData from '../configData.json';
import { format } from 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import { Link } from 'react-router-dom';
import LeftMenu from '../components/LeftMenu';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import GridDataPackages from '../components/gridmodal/GridDataPackages';
import MycustomDesignGrid from '../components/MycustomDesignGrid';
import { ValidDate, formatNumnberWithComma, formatAmountWithComma, formatDate, removeCommafromNumber, toLocalDate } from '../components/Utlities';


export default function ForwardDatedBills() {

    const [ForwardDatedBills, setForwardDatedBills] = useState([]);
    const [DetailByCustCarr, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});
    const [lastElement, setLastElement] = useState(null);
    const [hidden, setHidden] = useState(true);
    const [fbNum, setFbNum] = useState("");
    const [acctNo, setAcctNo] = useState("");

    const { ExportCSVButton } = CSVExport;
    const { ExportCSVButtonDetail } = CSVExport;

    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [fbLoading, setFBLoading] = useState(false);
    const [prevY, setPrevY] = useState(0);

    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let DetailByCustCarrRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    DetailByCustCarrRef.current = DetailByCustCarr;
    hiddenRef.current = hidden;
    pageRef.current = page;

    const criData = [
        { criKey: 1, criValue: 'Owner' },
        { criKey: 2, criValue: 'Customer' },
        { criKey: 3, criValue: 'Transportation Provider' },
        // { criKey: 4, criValue: 'Freight Bill Number' },
        // { criKey: 5, criValue: 'Transportation Provider Account Number' }
    ];

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const searchOnClick = (customerKey, carrierKey, startDate, endDate) => {

        setFromDate(startDate);
        setToDate(endDate);
        LoadSummaryData(customerKey, carrierKey, startDate, endDate);
    }

    const LoadSummaryData = async (customerKey, carrierKey, startDate, endDate) => {
        setLoading(true);
        setForwardDatedBills([]);
        const URL = `${configData.BASE_APP_URL}FreightBill/GetForwardDatedBillsSummary/${customerKey}/${carrierKey}/${startDate}/${endDate}`;
        console.log(URL);

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                const data = await response.json();

                // Convert 'packageCount', 'billedAmount', and 'paidAmount' to formatted strings in the response
                const modifiedResponse = data.map(item => ({
                    ...item,
                    packageCount: formatNumnberWithComma(item.packageCount),
                    billedAmount: formatAmountWithComma(item.billedAmount),
                    paidAmount: formatAmountWithComma(item.paidAmount)
                    // Add more properties as needed
                }));

                setForwardDatedBills(modifiedResponse);
            } else {
                console.error(`Error fetching data: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error during fetch:', error);
        } finally {
            setLoading(false);
        }
    };

    const LoadDetailData = async (customerKey, carrierKey, billType, setLoadingFunc, fromDetails) => {
        setLoadingFunc(true);
        setDetailData([]);
        const URL = `${configData.BASE_APP_URL}FreightBill/GetForwardDatedBillsDetailByPage/${customerKey}/${carrierKey}/${billType}/${fromDate}/${toDate}/${pageRef.current}/${configData.PAGE_SIZE}`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                const data = await response.json();

                // Convert 'billedAmount' and 'paidAmount' to formatted strings in the response
                const modifiedResponse = data.map(item => ({
                    ...item,
                    billedAmount: formatAmountWithComma(item.billedAmount),
                    paidAmount: formatAmountWithComma(item.paidAmount)
                    // Add more properties as needed
                }));

                setDetailData(modifiedResponse);
                // OpenPopup();
                setHidden(false);
            } else {
                console.error(`Error fetching data: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error during fetch:', error);
        } finally {
            setLoadingFunc(false);
        }
    };


    const columnFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <div>
                <span><a href='#'><i className="fa fa-expand mr-1"></i></a>{row.customerName}</span>
            </div>
        )
    }

    const IsManualFormatter = (cell) => {
        return (
            cell == 'Y' ? <span>Yes</span> : <span>No</span>
        )
    }

    const AmountFormatter = (cell) => {
        return (
            <span>{parseFloat(cell).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
        )
    }

    const invoicenumberFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=" + '"' + cell + '"'
        )
    }

    const dateFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (cell === "" || cell === null) {
            return <span></span>;
        }
        else {
            return (
                <span>{format(toLocalDate(cell), "MM/dd/yyyy")}</span>
            );
        }
    }

    const dateFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        let newDate = format(new Date(cell), "MM/dd/yyyy");
        return (
            "=SUBSTITUTE(" + '"' + newDate + '"' + "," + '"' + "-" + '"' + "," + '"' + "/" + '"' + ")"
        )
    }

    const imageLinkFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <a target="_blank" href={cell}>View</a>
        )
    }


    const imageLinkFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=HYPERLINK(" + '"' + cell + '",' + '"' + "View" + '"' + ")"
        )
    }

    const columnsDetail = [
        {
            dataField: 'freightBillNumber',
            text: 'Freight Bill/Package Number',
            headerStyle: { width: '180px', textAlign: 'center' },
            align: 'left',
            sort: true,
            csvFormatter: invoicenumberFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'invoiceNumber',
            text: 'Invoice Number',
            headerStyle: { width: '180px', textAlign: 'center' },
            align: 'left',
            sort: true,
            csvFormatter: invoicenumberFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'entryDate',
            text: 'Entry Date',
            headerStyle: { width: '80px', textAlign: 'center' },
            align: 'left',
            sort: true,
            formatter: dateFormatter,
            csvFormatter: dateFormattercsv
        },
        {
            dataField: 'invoiceDate',
            text: 'Invoice Date',
            headerStyle: { width: '80px', textAlign: 'center' },
            align: 'left',
            sort: true,
            formatter: dateFormatter,
            csvFormatter: dateFormattercsv
        },
        {
            dataField: 'cargoTypeDesc',
            text: 'Cargo Type',
            headerStyle: { width: '92px', textAlign: 'center' },
            align: 'center',
            sort: true
        },
        {
            dataField: 'status',
            text: 'Status',
            headerStyle: { width: '92px', textAlign: 'center' },
            align: 'center',
            sort: true
        },
        {
            dataField: 'freightBillReason',
            text: 'Freight Bill Reason',
            headerStyle: { width: '192px', textAlign: 'center' },
            align: 'left',
            sort: true
        },
        {
            dataField: 'billedAmount',
            text: 'Billed Amount',
            headerStyle: { width: '152px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'paidAmount',
            text: 'Paid Amount',
            headerStyle: { width: '92px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'forwardDatedBy',
            text: 'Forward Dated By',
            headerStyle: { width: '80px', textAlign: 'center' },
            align: 'left',
            sort: true
        },
        {
            dataField: 'forwardDatedOn',
            text: 'Forward Dated On',
            headerStyle: { width: '80px', textAlign: 'center' },
            align: 'left',
            sort: true,
            formatter: dateFormatter,
            csvFormatter: dateFormattercsv
        },
        {
            dataField: 'forwardComment',
            text: 'Forward Date Comment',
            headerStyle: { width: '400px', textAlign: 'center' },
            align: 'left',
            sort: true
        },
        {
            dataField: 'billType',
            text: 'Bill Type',
            headerStyle: { width: '110px', textAlign: 'center' },
            align: 'center',
            sort: true
        },
        {
            dataField: 'manualBill',
            text: 'Manually Bill?',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'center',
            sort: true,
            formatter: IsManualFormatter
        },
        {
            dataField: 'freightBillKey',
            text: 'Freight Bill Key',
            headerStyle: { width: '150px', textAlign: 'center' },
            align: 'left',
            filter: customFilter(),
            sort: true,
            // csvFormatter: freightBillFormattercsv,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />


        },
        {
            dataField: 'imageLink',
            text: 'Image Link',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'center',
            formatter: imageLinkFormatter,
            csvFormatter: imageLinkFormattercsv
        }
    ]

    let onCustomerFilter;
    let onCarrierFilter;
    const onCustomerChangeFilter = (selectedCust, selectedCarrier, selectedFromDate, selectedToDate) => {
        //debugger;
        // onCustomerFilter(val);

        setFromDate(selectedFromDate);
        setToDate(selectedToDate);
        LoadSummaryData(selectedCust, selectedCarrier, selectedFromDate, selectedToDate);
    };
    const onCarrierChangeFilter = (val) => {
        //onCarrierFilter(val);
        console.log(val)
    };

    const columns = [
        {
            dataField: 'id',
            text: 'Id',
            headerStyle: { width: '50' },
            hidden: true,
            csvExport: false,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'customerName',
            text: 'Customer',
            headerStyle: { width: '157px', textAlign: 'center' },
            formatter: columnFormatter,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setDetailData([]);
                    setPage(1);
                    const selectedRow = {
                        customerKey: row.customerKey,
                        customerName: row.customerName,
                        carrierKey: row.carrierKey,
                        carrierName: row.carrierName,
                        billType: row.billType,
                        totalBills: row.billCount,
                        totalPackages: row.packageCount
                    }
                    setSelectedRow(selectedRow);
                    LoadDetailData(row.customerKey, row.carrierKey, row.billType, setLoading, false);
                }
            },
            filter: customFilter(),
            filterRenderer: (onFilter, column) => {
                onCustomerFilter = onFilter;
                <ColumnFilter onFilter={onFilter} column={column} />
            }
        },
        {
            dataField: 'carrierName',
            text: 'Transportation Provider',
            headerStyle: { width: '285px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'billType',
            text: 'Bill Type',
            headerStyle: { width: '110px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'billCount',
            text: 'Total Number Of Bills',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'right',
            sort: true

        },
        {
            dataField: 'packageCount',
            text: 'Total Number of Packages',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'billedAmount',
            text: 'Billed Amount',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'right',
            sort: true

        },
        {
            dataField: 'paidAmount',
            text: 'Paid Amount',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'right',
            sort: true

        }
    ];


    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const options = {
        sizePerPageRenderer,
        sizePerPageList: [{
            text: '50', value: 50
        }, {
            text: '100', value: 100
        },
        {
            text: '200', value: 200
        }, {
            text: 'All', value: ForwardDatedBills.length
        }]
    };

    const detailOptions = {
        sizePerPageRenderer,
        sizePerPageList: [{
            text: '50', value: 50
        }, {
            text: '100', value: 100
        },
        {
            text: '200', value: 200
        }, {
            text: 'All', value: DetailByCustCarr.length
        }]
    };

    //to export summary report
    const DownloadSummaryData = async () => {
        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelForForwardBillSummaryReport`;
        // console.log(URL);

        const modifiedResponse = ForwardDatedBills.map(item => ({
            ...item,
            packageCount: removeCommafromNumber(item.packageCount),
            billedAmount: removeCommafromNumber(item.billedAmount),
            paidAmount: removeCommafromNumber(item.paidAmount)
            // Add more properties as needed
        }));

        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: modifiedResponse }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Forward Dated Bills Summary.xlsx`;
        link.click();
    };

    //to export detail report
    const DownloadDetailData = async () => {
        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelForForwardBillDetailReport`;

        const modifiedResponse = DetailByCustCarrRef.current.map(item => ({
            ...item,
            billedAmount: removeCommafromNumber(item.billedAmount),
            paidAmount: removeCommafromNumber(item.paidAmount)
            // Add more properties as needed
        }));

        console.log(JSON.stringify({ modifiedResponse }));
        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: modifiedResponse }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Forward Dated Bills Detail.xlsx`;
        link.click();
    };

    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Forward Dated Bills <span class="breadcumspan">(Forward Dated Bills in the past 7 days)</span>' }} />;

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>
                        <div className='floating-table-overlay' hidden={hidden}></div>
                        <div hidden={hidden} className="floating-table shadow-sm full-height-modal">
                            <div className='row g-0 p-2 bg-white'>
                                <button onClick={() => setHidden(!hidden)} className='close-modal'><i className="fas fa-times"></i></button>
                                <GridDataPackages data={selectedRowRef.current} />
                            </div>
                            <div className='border-top p-2 table-container'>
                                <div className='custom-table-text'>
                                    {DetailByCustCarr.length > 0 ?
                                        <ToolkitProvider
                                            keyField="freightBillKey"
                                            data={DetailByCustCarr}
                                            columns={columnsDetail}
                                            exportCSV={{ fileName: 'Forward Dated Bills Detail.csv' }}>
                                            {
                                                props => (
                                                    <div>
                                                        {/* <div className='sticky-sm-top'> */}

                                                        {/* </div> */}
                                                        <BootstrapTable
                                                            classes='table table-striped table-hover table-width-small'
                                                            headerClasses='table-top'
                                                            bootstrap4
                                                            pagination={paginationFactory(detailOptions)}
                                                            keyField='freightBillKey'
                                                            data={DetailByCustCarrRef.current}
                                                            columns={columnsDetail}
                                                            {...props.baseProps}
                                                            filter={filterFactory()}
                                                        />
                                                        {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i>Export</ExportCSVButton> 
                                                        */}<button className='btn react-bs-table-csv-btn' onClick={DownloadDetailData}><i className='fa fa-download'></i> Export
                                                        </button>
                                                    </div>
                                                )
                                            }
                                        </ToolkitProvider> : <>
                                            <MycustomDesignGrid column={columnsDetail} />
                                        </>}
                                </div>
                            </div>
                        </div>

                        {/* <Breadcrumbs title="Forward Dated Bills (Forward Dated Bills in the past 7 days)" /> */}
                        <Breadcrumbs title={breadcumTitle} />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                        <div className='sticky-top-content'>
                            <TopFilter oncustom={onCustomerChangeFilter} oncustom1={onCarrierChangeFilter} criData={criData} />
                        </div>
                        <div className='d-flex'>
                            <div className="table-container">
                                <div className='grid-toggle'>
                                    <div className='main-table-text dropup'>
                                        {ForwardDatedBills.length > 0 ?
                                            <ToolkitProvider
                                                keyField="id"
                                                data={ForwardDatedBills}
                                                columns={columns}
                                                exportCSV={{ fileName: 'Forward Dated Bills Summary.csv' }}>
                                                {
                                                    props => (
                                                        <div>
                                                            {/* <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: 'right' }}>
                                                                <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export </ExportCSVButton>
                                                            </div> */}
                                                            <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: 'right' }}>
                                                                <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                                                </button>
                                                            </div>
                                                            <BootstrapTable
                                                                classes='table table-striped table-hover table-width'
                                                                headerClasses='table-top'
                                                                bootstrap4
                                                                pagination={paginationFactory(options)}
                                                                {...props.baseProps}
                                                                filter={filterFactory()}
                                                            />
                                                            {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider> : <>
                                                <MycustomDesignGrid column={columns} />
                                            </>}

                                    </div>
                                </div>
                            </div>
                            <RightFilterToggle onSearchClick={searchOnClick} isFbNoDisabled="true" isAccNoDisabled="true" />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}